import { combineReducers } from 'redux';

const questions = (state = { totalCount: 0, result: [] }, action) => {
  switch (action.type) {
    case 'FETCH_QUESTIONNAIRE_QUESTIONS_FULFILLED':
      return action.payload.data;
    case 'FETCH_QUESTIONNAIRE_QUESTIONS_REJECTED':
      return { totalCount: 0, result: [] };
    default:
      return state;
  }
};

const questionTypeScores = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_SCORES_FULFILLED':
      return action.payload.data.questionTypes;
    case 'FETCH_SCORES_REJECTED':
      return [];
    default:
      return state;
  }
};

const displayCategoriesScores = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_SCORES_FULFILLED':
      return action.payload.data.displayCategories;
    case 'FETCH_SCORES_REJECTED':
      return [];
    default:
      return state;
  }
};

const scoresLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_SCORES_FULFILLED':
    case 'FETCH_SCORES_REJECTED':
      return true;
    case 'FETCH_SCORES_PENDING':
      return false;
    default:
      return state;
  }
};

const instance = (state = { result: [], vendorContactID: null }, action) => {
  switch (action.type) {
    case 'FETCH_QUESTIONNAIRE_INSTANCE_FULFILLED':
      return action.payload.data;
    case 'FETCH_QUESTIONNAIRE_INSTANCE_REJECTED':
      return { result: [], vendorContactID: null };
    default:
      return state;
  }
};

const instanceIsFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_QUESTIONNAIRE_INSTANCE_PENDING':
      return true;
    case 'FETCH_QUESTIONNAIRE_INSTANCE_FULFILLED':
    case 'FETCH_QUESTIONNAIRE_INSTANCE_REJECTED':
      return false;
    default:
      return state;
  }
};
const instanceErrorMessage = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_QUESTIONNAIRE_INSTANCE_PENDING':
    case 'FETCH_QUESTIONNAIRE_INSTANCE_FULFILLED':
      return null;
    case 'FETCH_QUESTIONNAIRE_INSTANCE_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_QUESTIONNAIRE_QUESTIONS_PENDING':
      return true;
    case 'FETCH_QUESTIONNAIRE_QUESTIONS_REJECTED':
    case 'FETCH_QUESTIONNAIRE_QUESTIONS_FULFILLED':
      return false;
    default:
      return state;
  }
};

const errorMessage = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_QUESTIONNAIRE_QUESTIONS_PENDING':
    case 'FETCH_QUESTIONNAIRE_QUESTIONS_FULFILLED':
      return null;
    case 'FETCH_QUESTIONNAIRE_QUESTIONS_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const questionnaire = combineReducers({
  questions,
  questionTypeScores,
  displayCategoriesScores,
  isFetching,
  errorMessage,
  instance,
  instanceIsFetching,
  instanceErrorMessage,
  scoresLoaded,
});

export default questionnaire;
